import React from "react";
import { useNavigate } from "react-router-dom";
import SplashComponent from "../../../Component/ReusableComponent/SplashComponent/SplashComponent";
import "./SplashScreen.css";

import BackgroundImage from "../../../Assets/LoginScreenAdmin/imagebackground.png";
import Logo from "../../../Assets/LoginScreenAdmin/Logo.png";

// Rotating images
import splash1 from "../../../Assets/SplashImages/splashimage1.png";
import splash2 from "../../../Assets/SplashImages/splashimage2.png";
import splash3 from "../../../Assets/SplashImages/splashimage3.png";
import splash4 from "../../../Assets/SplashImages/splashimage4.png";

// Mini icons
import mini1 from "../../../Assets/SplashImages/mini1.png";
import mini2 from "../../../Assets/SplashImages/mini2.png";
import mini3 from "../../../Assets/SplashImages/mini3.png";
import mini4 from "../../../Assets/SplashImages/mini4.png";
import mini5 from "../../../Assets/SplashImages/mini5.png";
import mini6 from "../../../Assets/SplashImages/mini6.png";

export default function FliplynSplashPage() {

  const navigate = useNavigate();

  const rotatingImages = [splash1, splash2, splash3, splash4];

  const minis = [mini1, mini2, mini3, mini4, mini5, mini6];

  const handleClick = () => {
    navigate("/stalls-user");
  };

  return (
    <SplashComponent
      className="fliplyn-splash-theme"
      logo={Logo}
      title="Fliplyn"
      backgroundImage={BackgroundImage}
      rotatingImages={rotatingImages}
      minis={minis}
      orderButtonText="ORDER & PAY HERE"

      onClick={handleClick}
    />
  );
}